import { useEffect, useState } from "react";
import { GetSearchData } from "../CRUDPage/FetchData";

const drug_name_list = {"ACETAZOLAMIDE": "ACETAZOLAMIDE 250MG TAB", "ADRENERGIC": "ADRENERGIC", "ALPHAGAN P": "ALPHAGAN P  5ML", "ANTI-HYPERTENSION": "ANTI-HYPERTENSION", "AZOPT": "AZOPT  5ML", "CARTOLOL": "CARTOLOL 2% 5ML", "CA-CHANNEL BLOCKER": "CA-CHANNEL BLOCKER", "COMBIGAN": "COMBIGAN  5ML", "COSOPT": "COSOPT  5ML", "EYBELIS": "EYBELIS 20MCG 2.5ML", "ISOPTO": "ISOPTO 2% 15ML", "LATAN": "LATAN  2.5ML", "LATA2": "LATANOPROST  2.5ML", "LUMIGAN": "LUMIGAN (單支) 30支", "MANNITOL": "MANNITOL  100ML", "RAYNAUD": "RAYNAUD", "SULFA-BASED": "SULFA-BASED", "STEROID": "STEROID", "TIMOLOL": "TIMOLOL 0.5% 5ML", "TRUSOPT": "TRUSOPT  5ML", "VYZULTA": "VYZULTA  5ML", "XALATAN": "XALATAN  2.5ML"};

function ListAllDrug({patientData}){
    const [InfoContent, setInfoContent] = useState([]);

    let gettingData = GetSearchData("drug_record/"+patientData.client_data_record_id);

    useEffect(() => {
        try{
            if(typeof gettingData === "object" && gettingData.hasOwnProperty("message")){
                console.log("error:",gettingData)
            }
            else if(typeof gettingData === "object" && !gettingData.hasOwnProperty("message")){
                console.log(gettingData)
                let sortedData = [...gettingData].sort((a,b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
                console.log('sort', sortedData)
                setInfoContent(sortedData);
            }
        }
        catch(error){
            console.log("error:", error)
        }
    }, [gettingData])

    return(
        <div className="text-xl flex justify-center overflow-auto w-full">
            <table >
                <thead>
                    <tr >
                        <td className="w-auto">給藥時間</td>
                        <td className="p-4 w-auto">藥名</td>
                        <td className="p-4 w-auto">頻率</td>
                        <td className="p-4 w-auto">總天數</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        InfoContent.map((record) => (
                            <tr>
                                <td className="w-auto">{record.start_date}</td>
                                <td className="p-4 w-auto">{drug_name_list[record.drug]}</td>
                                <td className="p-4 w-auto">{record.drug_frequency}</td>
                                <td className="p-4 w-auto">{record.drug_due_day}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ListAllDrug;
